import { useEffect, useState } from 'react'

/**
 * A search field whose value lives in the URL.
 *
 * Typing stays local so the input never lags, and the URL — and therefore the
 * query — only follows once typing pauses.
 */
export function SearchBox({
  value,
  onChange,
  label,
  placeholder,
  id,
}: {
  value: string
  onChange: (next: string) => void
  label: string
  placeholder?: string
  id: string
}) {
  const [draft, setDraft] = useState(value)

  // Keep in step when the URL changes from elsewhere (back button, Clear).
  useEffect(() => setDraft(value), [value])

  useEffect(() => {
    if (draft === value) return
    const timer = setTimeout(() => onChange(draft), 350)
    return () => clearTimeout(timer)
  }, [draft, value, onChange])

  return (
    <div className="field" style={{ flex: 1, minWidth: 220 }}>
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="search"
        placeholder={placeholder}
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
      />
    </div>
  )
}
